import { Typography } from "@mui/material";
import DataTable from "./DataTable";
import { useState } from "react";
import { masterStructure, lengthOfAddedUrls, academicTerms } from "./masterStructure";
import { parseMarksString, averageTermMarks } from "./marksUtils";

export default function DataDisplay(props) {
  const dataSelection = props.dataSelection;

  const [filterOptions, setFilterOptions] = useState({
    termSelect: "GS Average",
  });

  const formattedStudentData = masterStructure.map((dataCategory, index) => {
    let dataFilled = false;
    let arrayFlipped = false;
    let formatAsButton = false;
    let insertBr = false;
    let healthTracker = false;
    let formatGraph = false;
    let hideHeader = false;
    let indivMarks = false;
    let acadienceScores = false;

    let dataObject = dataCategory[Object.keys(dataCategory)[0]];

    for (const y in dataObject) {
      if (dataCategory["options"]) {
        if (
          dataCategory["options"]["isReverse"] &&
          dataSelection[dataSelection.length - dataObject[y]]
        ) {
          dataFilled = true;
        } else if (
          dataSelection[dataObject[y]] &&
          dataSelection.length - lengthOfAddedUrls > dataObject[y] &&
          !dataCategory["options"]["isReverse"] &&
          !dataCategory["options"]["isGraph"]
        ) {
          dataFilled = true;
        } else if (
          dataCategory["options"]["isGraph"] &&
          academicTerms.some(
            (term) =>
              dataSelection[term.gsIndex] || dataSelection[term.jsIndex],
          )
        ) {
          dataFilled = true;
        }
        insertBr = dataCategory["options"]["insertBr"];

        healthTracker = dataCategory["options"]["healthTracker"];
        arrayFlipped = dataCategory["options"]["isReverse"];
        formatAsButton = dataCategory["options"]["isLink"];
        formatGraph = dataCategory["options"]["isGraph"];
        hideHeader = dataCategory["options"]["hideHeader"];
        indivMarks = dataCategory["options"]["indivMarks"];
        acadienceScores = dataCategory["options"]["acadienceScores"];
      } else if (
        dataSelection[dataObject[y]] &&
        dataSelection.length - lengthOfAddedUrls > dataObject[y]
      ) {
        //If the student data includes the required index and the index is within the columns in the original
        dataFilled = true;
      }
    }

    // Each "Average Marks by Class (YYYY-YY)" entry carries its own term1/term2 column
    // indices in the masterStructure, so the average can always be derived on the spot —
    // no per-year state or flags needed when a new school year is added.
    const termMarksAvg = indivMarks
      ? averageTermMarks(
          parseMarksString(dataSelection[dataObject.term1]),
          parseMarksString(dataSelection[dataObject.term2]),
        )
      : [];

    return (
      dataFilled && (
        <div key={Object.keys(dataCategory)[0] + index}>
          <Typography variant="h6">{Object.keys(dataCategory)[0]}</Typography>
          <DataTable
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            arrayFlipped={arrayFlipped}
            formatAsButton={formatAsButton}
            insertBr={insertBr}
            healthTracker={healthTracker}
            indivMarks={indivMarks}
            isGraph={formatGraph}
            acadienceScores={acadienceScores}
            termMarksAvg={termMarksAvg}
            dataPacket={dataObject}
            dataTitle={Object.keys(dataCategory)[0]}
            studentInfo={dataSelection}
            rawData={props.rawData}
            hideHeader={hideHeader}
          />
          <br />
        </div>
      )
    );
  });

  return (
    <div className="studentInfoContainer">
      <Typography variant="h4" className="studentInfoText">
        Student Information
      </Typography>
      <br />
      {formattedStudentData}
    </div>
  );
}
